<template>

    <transition name="home-animated" enter-active-class="animated rotateIn" leave-active-class="animated rotateOut" >
        <div class="page white">
            <v-layout align-center justify-center fill-height>
                <div class="text-xs-center">
                    <h1 class="display-1 mb-2">Registre horari</h1>
                    <h2 class="font-weight-light">Configuració inicial:</h2>

                    <v-form
                            ref="form"
                            lazy-validation
                            onSubmit="return false;"
                    >

                        <div style="position:relative;">

                            <div class="box_progress" v-if="loading">
                                <v-progress-circular
                                        indeterminate
                                        color="blue"
                                ></v-progress-circular>
                            </div>
                            <v-container>
                                <v-layout>
                                    <v-flex
                                            md12
                                    >
                                        <v-text-field
                                                v-model="codi"
                                                :counter="16"
                                                :error="error"
                                                :error-messages="errorTxt"
                                                :success="success"
                                                :success-messages="successTxt"
                                                :hide-details="hideDetails"
                                                label="Introdueix el codi"
                                                v-on:keyup="checkAvailable"
                                                maxlength="16"
                                                required
                                        ></v-text-field>
                                    </v-flex>

                                </v-layout>
                            </v-container>

                        </div>

                        <v-btn :disabled="disabledButton" type="submit" @click="getTokenFromCodi" color="primary" large>Validar codi</v-btn>

                    </v-form>



                </div>

            </v-layout>
        </div>
    </transition>

</template>

<script>

    import { mapState, mapActions } from "vuex"

    import axios from "axios"

    export default {
        data(){
            return{
                codi: '',
                loading: false,
                error: false,
                success: false,
                errorTxt: [],
                successTxt: [],
                hideDetails: false,
                disabledButton: true
            }
        },
        computed: {
            ...mapState(['appObject', 'urlAPI']),
        },
        methods: {
            ...mapActions(['setStorage']),
            //this.$data.loading = false;

            //A partir del codi del formulari agafem la informació
            async getTokenFromCodi( event ){

                this.loading = true;

                this.hideDetails = true
                this.error = false,
                this.errorTxt = []

                //console.log('agafem el codi!');
                console.log(this.codi); //Podem extreure la data

                //Utilitzem axios per fer la crida per post a l'API
                //Son sempre crides asíncrones, per tant podem utilitzar "await" (ES7) en comptes de tractar el then() típic de les promeses
                const params = new URLSearchParams(); //Per defecte "axios" serialitza l'objecte javascript a JSON, no tenim la API apunt per rebre json li hem d'enviar en "application/x-www-form-urlencoded"
                params.append('codi', this.codi);
                let dades = await axios.post(`${this.urlAPI}verificarcodi`, params)
/*                let dades = await axios({
                    url: `${this.urlAPI}verificarcodi`,
                    method: 'POST',
                    mode: 'no-cors',
                    //withCredentials: true, Això és per si vulguéssim incloure cookies en la solicitud
                    data: {
                        codi: this.codi
                    }
                })*/
                //let dades = await axios.get('usuari.json'); // Si vulguéssim agafar un json d'algun arxiu en local

                console.log(dades);
                let info = dades.data;

                //Guardem les dades
                this.setStorage( info )

                //Posem una mica de delay
                setTimeout(() => {
                    this.loading = false
                    this.hideDetails = false

                    if (info.error) {
                        this.error = true
                        this.errorTxt = [info.error]

                    }else{

                        this.success = true
                        this.successTxt = [info.success]

                        setTimeout(() => {
                            //Enviem a la pantalla de la home
                            this.$router.push('/home');
                        },2000)
                    }

                }, 2000);


                console.log(info)

            },

            //Funció per netejar errors i comprovar si habilitem el botó de submit
            checkAvailable(){
                
                //Amaguem els erros quan escrivim
                this.hideDetails = false
                this.error = false
                this.errorTxt = []

                //Habilitem el botó només a 16 digits
                if(this.codi.length == 16) this.disabledButton = false
                else this.disabledButton = true

            }
        },

    }
</script>


<style>
    .v-form{position: relative;}
    .box_progress{position:absolute;width: 100%;height: 100%;background: #fff;text-align: center;z-index:10000;display: flex;justify-content: center;align-items: center;}
</style>
